import React from "react"
import { useTheme } from "styled-components"

import { CelebrityCard, CelebrityImage } from "./styles"

const TestimonialCelebrityCard = ({
  text,
  excerpt,
  image,
  attribName,
  attribTitle,
  dataId,
  hideOnPageLoad,
  ...props
}) => {
  const theme = useTheme()

  return (
    <CelebrityCard hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} {...props}>
      <h2 dangerouslySetInnerHTML={{ __html: excerpt }} />
      <CelebrityImage
        baseUrl={image}
        images={[
          { screenSize: 1200, transforms: "c_fill,g_auto,w_405,h_270,q_auto,f_auto,fl_lossy" },
          { transforms: "c_fill,g_auto,w_535,h_356,q_auto,f_auto,fl_lossy" },
        ]}
        lazy={!theme.component.onTop}
      />
      <h3>{attribName}</h3>
      <h4>{attribTitle}</h4>
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </CelebrityCard>
  )
}

export default TestimonialCelebrityCard
